export default "__VITE_ASSET__Ckk46i$6__"